import React, { useRef, useState } from 'react';
import { connect } from 'react-redux';

import { Button, Popover } from '@mui/material';

import FilterIcon from '@mui/icons-material/FilterList';
import SortersIcon from '@mui/icons-material/SortByAlpha';

import Filters from '../../../../../common/Filters';
import Sorters from '../../../../../common/Sorters';
import { isNotPlaceholderFilter, getRstDataMap } from '../../../../../utils';

const RstFilters = ({
  nodes,
  classes,
  settings,
  initialFilters,
  sortersCallbacks,
  filtersCallbacks,
  light_meta_and_ops,
  pidsForFilters = [],
  pidsForSorters = [],
}) => {
  const [showFiltersPopover, setShowFiltersPopover] = useState(false);
  const [showSortersPopover, setShowSortersPopover] = useState(false);

  const tableHeadingBtn = `${classes.btn} ${classes.btnEmpty} ${classes.tableHeadingBtn}`;

  const filterBtnRef = useRef(null);
  const sorterBtnRef = useRef(null);

  const popoverStyles = {
    marginTop: '10px',
    overflow: 'visible',
    boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.16)',
  };

  const initialSorters = {
    sort_pid: settings.sort_pid,
    sort_desc: settings.sort_desc,
    sort_by: settings.sort_by,
  };

  const filtersRstDataMap = getRstDataMap(pidsForFilters, settings.concept, light_meta_and_ops.setup_rbox_light);
  const sortersRstDataMap = getRstDataMap(pidsForSorters, settings.concept, light_meta_and_ops.setup_rbox_light);

  let filtersCounter = 0;

  if (!initialFilters.length && settings.trpl_filter) {
    initialFilters.push(...settings.trpl_filter);
  }

  if (settings.trpl_filter) {
    filtersCounter = settings.trpl_filter.filter(isNotPlaceholderFilter).length;
  }

  return (
    <div className={`${classes.alignCenter} ${classes.mb10}`}>
      {settings.concept ? (
        <React.Fragment>
          <Button
            size="small"
            ref={filterBtnRef}
            style={{
              border: `${showFiltersPopover ? '1px solid #D9D8ED' : '1px solid transparent'}`,
            }}
            aria-describedby="filters-popover"
            onClick={(e) => setShowFiltersPopover(true)}
            className={`${tableHeadingBtn} ${filtersCounter ? classes.tableMenuSelectedBtn : ''}`}
          >
            <FilterIcon className={classes.tableHeadingBtnIcon} />{' '}
            <span className={classes.tableHeadingBtnText}>
              {!filtersCounter ? 'Filter' : `Filters: ${filtersCounter}`}
            </span>
          </Button>

          <Popover
            id="filters-popover"
            open={showFiltersPopover}
            anchorEl={filterBtnRef.current}
            PaperProps={{
              style: popoverStyles,
            }}
            onClose={() => setShowFiltersPopover(false)}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
          >
            <Filters
              nodes={nodes}
              loaded={true}
              defaultBg={true}
              ancestor={settings.concept}
              rstDataMap={filtersRstDataMap}
              callbacks={filtersCallbacks}
              initialFilters={initialFilters}
              filterBtnText="Apply"
            />
          </Popover>

          <Button
            size="small"
            ref={sorterBtnRef}
            aria-describedby="filters-popover"
            onClick={(e) => setShowSortersPopover(true)}
            className={`${tableHeadingBtn} ${initialSorters.sort_pid ? classes.tableMenuSelectedBtn : ''}`}
            style={{
              border: `${showSortersPopover ? '1px solid #D9D8ED' : '1px solid transparent'}`,
            }}
          >
            <SortersIcon className={classes.tableHeadingBtnIcon} />{' '}
            <span className={classes.tableHeadingBtnText}>Sorte{initialSorters.sort_pid ? 'd' : 'r'}</span>
          </Button>

          <Popover
            id="sorters-popover"
            open={showSortersPopover}
            anchorEl={sorterBtnRef.current}
            PaperProps={{
              style: popoverStyles,
            }}
            onClose={() => setShowSortersPopover(false)}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
          >
            <Sorters rstDataMap={sortersRstDataMap} callbacks={sortersCallbacks} initialSorters={initialSorters} />
          </Popover>
        </React.Fragment>
      ) : null}
    </div>
  );
};

export default connect((state) => ({
  light_meta_and_ops: state.meta.light_meta_and_ops,
}))(RstFilters);
